export default "__VITE_ASSET__CxTwg2dH__"